import {Col, Row} from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding: 16px;
    margin-top: 30px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);

    @media (max-width: 768px) {
        margin-top: 80px;
    }
`;

export const SectionTabRow = styled(Row)`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    position: absolute;
    top: -20px;
    left: 0;
    z-index: 10;
    gap: 8px;
    flex-wrap: nowrap;

    @media (max-width: 768px) {
        flex-direction: row;
        align-items: center;
        left: 8px;
        right: 8px;
        width: calc(100% - 16px);
    }
`;

export const SectionTab = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: auto;
    height: auto;
    background-color: #fff;
    position: absolute;
    left: 0;
    top: -85px;
    border-radius: 10px;
    //figma dropshadow x:3 y:4 bluer:10.8 spread:0 color:rgba(0,0,0,0.25)
    box-shadow: 3px 4px 10.8px 0px rgba(0, 0, 0, 0.25);
    margin-right: 10px;
    margin-top: -85px;
    padding: 13px 10px 20px 10px;
    font-weight: 700;
    font-size: 16px;
    z-index: -1;
`;

export const SectionIcon = styled.img`
    margin-right: 5px;
    width: 20px;
    height: 20px;
`;

export const MapWrapper = styled.div`
    cursor: pointer;
`;

export const MapImage = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 10px;
`;

export const TableCell = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;
export const TableDetailIcon = styled.img`
    cursor: pointer;
`;

export const CustomTabRow = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 10px;
`;

export const CustomTab = styled.div`
    margin-right: 15px;
    font-weight: ${props => (props.active ? "700" : "400")};
    cursor: pointer;
    text-decoration: ${props => (props.active ? "underline" : "none")};
`;

export const SectionTabButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    background-color: ${props => (props.active ? "#AEF001" : "white")};
    border: 1px solid ${props => (props.active ? "#AEF001" : "#d9d9d9")};
    color: #000;
    font-weight: ${props => (props.active ? "bold" : "normal")};
    border-radius: 6px;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    margin-right: 8px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
    flex-shrink: 0;

    @media (max-width: 768px) {
        flex: 1;
        justify-content: center;
        margin-right: 0;
        min-width: 0;
        flex-wrap: wrap;
        height: 80px;

        &:not(:last-child) {
            margin-right: 8px;
        }
    }

    &:hover {
        background-color: ${props => (props.active ? "#AEF001" : "#f5f5f5")};
        border-color: ${props => (props.active ? "#AEF001" : "#40a9ff")};
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(174, 240, 1, 0.2);
    }
`;

export const ManuelDeliveryButton = styled.div`
    width: auto;
    height: auto;
    background-color: #fff;
    position: absolute;
    border-radius: 10px;
    //figma dropshadow x:3 y:4 bluer:10.8 spread:0 color:rgba(0,0,0,0.25)
    box-shadow: 3px 2px 10.8px 0px rgba(0, 0, 0, 0.15);
    top: ${props => (props.isMobile ? "-80px" : "-25px")};
    ${props => (props.isMobile ? "left: 8px;" : "right: 8px;")}
    padding: 10px 20px;
    z-index: 10;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    img {
        max-height: 60px;
        margin-right: 5px;
    }

    &:hover {
        background-color: #f2f2f2;
    }
`;
